<!-- src/components/HouseFillSvgrepoCom1.vue -->
<template>
  <div :class="[
    'house-fill-svgrepo-com-1',
    className || '',
    { 'house-fill-svgrepo-com-1--header': variant === 'header' }
  ]">
    <svg
      v-if="variant === 'header'"
      class="house-svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" 
        :fill="color"
      />
    </svg>
    <template v-else>
      <img
        class="vector-282"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-68.svg"
        alt=""
        role="presentation"
      />
      <img
        class="vector-283"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-163.svg"
        alt=""
        role="presentation"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: "HouseFillSvgrepoCom1",
  props: {
    className: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'default',
      validator: value => ['default', 'header'].includes(value)
    },
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style>
/* Оригинальные стили для обратной совместимости */
.house-fill-svgrepo-com-1 {
  aspect-ratio: 1;
  height: 27px;
  left: 0;
  position: absolute;
  top: 3px;
  width: 27px;
}

.vector-282 {
  height: 81.25%;
  left: 12.5%;
  position: absolute;
  top: 12.5%;
  width: 75%;
}

.vector-283 {
  height: 48.71%;
  left: 3.12%;
  position: absolute;
  top: 7.55%;
  width: 93.76%;
}

/* Вариации классов */
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-1 .vector-283,
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-2 .vector-283,
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-4 .vector-283,
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-6 .vector-283,
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-9 .vector-283,
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-10 .vector-283,
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-11 .vector-283,
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-12 .vector-283,
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-13 .vector-283,
.house-fill-svgrepo-com-1.house-fill-svgrepo-com-1-14 .vector-283 {
  top: 7.54%;
}

/* Новые стили для header варианта */
.house-fill-svgrepo-com-1--header {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.house-fill-svgrepo-com-1--header .house-svg {
  width: 100%;
  height: 100%;
  transition: transform 0.2s ease;
}

.house-fill-svgrepo-com-1--header:hover .house-svg {
  transform: scale(1.1);
}

/* Активное состояние для роутера */
.router-link-active .house-fill-svgrepo-com-1--header .house-svg {
  color: var(--primary-color, #007bff);
}
</style>